export const SubmissionError = ({key, message}) => {
    this.key = key
    this.message = message
    this.name = 'SubmissionError'
}

